import axios from "axios";
import router from "../router";
import { getLanguage } from "../lang/index";
import { Loading } from "element-ui";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASH_URL,
  // timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": getLanguage()
  }
});
// var token = localStorage.setItem(response.data.UserName, response.data.Ticket)
// console.log(token, 887)
// http request 请求拦截器，有token值则配置上token值

const apiList = [
  "api/SU_System/CheckAuthCode",
  "api/SU_Login/UserLogin",
  "api/SU_Login/RegisterUser",
  "api/C_Index/C_LoadIndex",
  "api/C_Index/C_LoadAppIndex",
  "api/C_Index/LoadCProductByPage",
  "api/C_Index/C_LoadSpecialProduct",
  "api/C_Product/LoadProductClass",
  "api/C_Search/LoadSearchKeyWords",
  "api/C_Search/LoadSearchProductByPage",
  "api/SU_Customer/LoadHomeIndex",
  "api/SU_Customer/GetTopProductAndClassInfo",
  "api/SU_Product/GetBusinessProductClassList",
  "api/SU_Product/GetProductSearchList",
  "api/SU_Product/GetSupplierProductInfo",
  "api/SU_Customer/GetSupplierShopHomePage",
  "api/SU_Customer/LoadContactSupplier",
  "api/SU_Customer/GetCountryInfoList",
  "api/SU_Customer/GetProvinceInfoList",
  "api/SU_Customer/GetCityInfoList",
  "api/SU_Customer/AddContactSupplier"
];

var loadingInstance = null;

instance.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({
      fullscreen: true,
      background: "rgba(0, 0, 0, 0.8)",
    });

    if (apiList.findIndex(item => config.url === item) !== -1) {
      return config;
    }
    let { token } = JSON.parse(localStorage.getItem("auth")) || {};

    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }

    return config;
  },
  err => {
    loadingInstance.close();

    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  response => {
    loadingInstance.close();

    const data = response.data;
    if (data.StatusCode === 200) {
      return {
        code: 200,
        data: data.Data,
        meta: {
          page: data.PageIndexs,
          total: data.DataCounts,
          lastPage: data.ALLPages
        }
      };
    } else {
      const error = { code: data.StatusCode, message: data.Message };
      return Promise.reject(error);
    }
  },
  error => {
    loadingInstance.close();

    var customError;
    if (error && error.response && error.response.data) {
      if (
        error.response.data.StatusCode === 401 ||
        error.response.data.StatusCode === 403
      ) {
        localStorage.removeItem("auth");
        router.push({
          path: "/"
        });
      }
      customError = {
        code: error.response.data.StatusCode,
        message: error.response.data.Message
      };
    } else {
      customError = { code: 0, message: "网络错误" };
    }
    // console.log(error)

    // console.log('Error', error.response)
    return Promise.reject(customError);
  }
);

export default instance;
